<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
     <div class="mt-6 flex items-center justify-between px-6">
        <h3>ADD GROUP FOR:</h3>
         <vs-chip  color="primary" class="mr-8">
      <p >{{dataLocationName}}</p>
    </vs-chip>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

     <div class="p-6">
        <vs-input label="Name *"   v-model="dataName" class="w-full" name="name" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span><br>
       <label class="vs-select--label w-full">Select Camera</label>
        <v-select  label="name" multiple :closeOnSelect="true" v-model="dataCamera"  :options="cameras"  /><br>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import {CREATE_LOCATION_GROUP,} from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  data () {
    return {
      dataId:null,
      dataName:null,
      dataLocationName:null,
      cameras:[],
      dataCamera:[],

      enableBtn:true,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id,name,cameras } = JSON.parse(JSON.stringify(this.data))
        this.initValues()
        this.$validator.reset()
        this.dataId=id
        this.dataLocationName=name
        this.cameras=cameras
        this.enableBtn=true
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.enableBtn  
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    alertNofity (color,text) {
      this.$vs.notify({
        color: color,
        title: "Location",
        position: 'top-right',
        text: text
      })
    },
    initValues () {
      this.dataId = null
      this.dataName = null
      this.dataLocationName=null
      this.cameras=[]
      this.dataCamera=[]
    },
    submitData () {
      var cameras =[];
      for (let index = 0; index < this.dataCamera.length; index++) {
        cameras.push(this.dataCamera[index].id)
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.enableBtn=false
          this.$apollo
            .mutate({
              mutation: CREATE_LOCATION_GROUP,
              variables: {
                name: this.dataName,
                location:this.dataId,
                cameras:cameras
              }
            }).then(response => {
              console.log(response)
              if (response.data.createLocationGroup.status == 'Success') {
                this.alertNofity(response.data.createLocationGroup.color,response.data.createLocationGroup.message)
                this.enableBtn=true
                this.$emit('closeSidebar')
                this.$emit('getdata', true)
              }else{
                  this.alertNofity(response.data.createLocationGroup.color,response.data.createLocationGroup.message)
                  this.enableBtn=true
              }
            }).catch(error => {
              console.log(error)
               this.enableBtn=true
            })


        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
